module.exports = __webpack_public_path__ + "static/media/washing-machine (1).00af4f62.png";